export default {
  name: 'Article list section - 5',
  tab: 'article list',
  type: 'category-listing-default-section',
  content: {
    title: 'Category listing section',
    introtext:
      '<p>Donec id elit non mi porta gravida at eget metus. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Maecenas sed diam eget risus varius blandit sit amet non magna.</p>',
    articles:
      '[{"article-title":"Article 1","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"","button-link":"","button-style":"default","button-background-color":"var(--primary-color)","button-text-color":"var(--text-light-color)"},{"article-title":"Article 2","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"","button-link":"","button-style":"default","button-background-color":"var(--primary-color)","button-text-color":"var(--text-light-color)"}]'
  },
  design: {
    'background-color': 'var(--primary-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'var(--text-light-color)',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h2',
    'introtext-color': 'var(--text-light-color)',
    'article-title-color': 'var(--text-light-color)',
    'article-title-font-weight': 'lighter',
    'article-title-tag': 'h6',
    'article-introtext-color': 'var(--text-light-color)'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'center',
    'article-columns': '2',
    'content-box': '1',
    'content-box-wrap': 'item',
    'content-box-color': 'var(--primary-color)',
    'content-box-padding': '40px',
    'content-box-opacity': '0.15',
    'content-box-elevation': '14',
    'content-box-border': '1',
    'content-box-border-color': 'var(--text-light-color)',
    'content-box-rounded': '1'
  },
  advanced: {}
}
